var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaneSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 249,
  height: 150,
  viewBox: "0 0 249 150",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#E3E0FF",
  d: "M146.346 0c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h55.112c5.525 0 10.004 4.477 10.004 10s-4.479 10-10.004 10h37.037c5.526 0 10.005 4.477 10.005 10s-4.48 10-10.005 10h-32.75c-5.525 0-10.004 4.477-10.004 10s4.479 10 10.004 10h2.05c5.525 0 10.005 4.477 10.005 10s-4.48 10-10.005 10H54.13c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10H35.682c-5.526 0-10.005-4.477-10.005-10s4.48-10 10.005-10h19.877c5.526 0 10.005-4.477 10.005-10s-4.48-10-10.005-10H10.505C4.979 40 .5 35.523.5 30s4.48-10 10.005-10h66.493c-5.525 0-10.005-4.477-10.005-10s4.48-10 10.005-10h69.348zm88.635 80.374c5.407 0 9.79 4.393 9.79 9.813 0 5.42-4.383 9.813-9.79 9.813-5.406 0-9.789-4.393-9.789-9.813 0-5.42 4.383-9.813 9.79-9.813z",
  transform: "translate(-63 -183) translate(63 185) translate(0 48) matrix(-1 0 0 1 249 0)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6659FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M102.134 40.68l11.6-11.2M97.406 45.246l1.5-1.449m2.84-12.065l5.52-5.331M105.81 53.569L87.223 70.307m26.972-13.943l-5.665 5.1",
  transform: "translate(-63 -183) translate(63 185) translate(0 48)"
}))), /*#__PURE__*/React.createElement("g", {
  stroke: "#6659FF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M100.083.073L2.021 49.593c-2.89 1.459-2.622 5.67.43 6.75l23.625 8.372c.425.15.898.061 1.24-.234L100.77 1.097c.554-.479-.032-1.355-.687-1.024",
  transform: "translate(-63 -183) translate(63 185) translate(98) translate(.758 .358) translate(.242 .642)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E0FF",
  d: "M30.223 84.146c.347 1.927 2.798 2.552 4.026 1.027l67.368-83.676c.33-.41-.22-.941-.618-.597l-73.7 63.595c-.332.287-.488.728-.41 1.16l3.334 18.491z",
  transform: "translate(-63 -183) translate(63 185) translate(98) translate(.758 .358) translate(.242 .642)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6659FF",
  d: "M32.89 85.331l6.905-14.503c1.57-3.297 3.623-6.342 6.091-9.033L94.258 9.066c.43-.47 1.147.147.748.643L33.708 85.845c-.362.449-1.065.006-.817-.514",
  transform: "translate(-63 -183) translate(63 185) translate(98) translate(.758 .358) translate(.242 .642)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M44.775 66.982l39.86 17.2c2.302.993 4.927-.425 5.359-2.894l13.75-78.603c.25-1.43-1.52-2.303-2.501-1.233L44.086 63.758c-.941 1.025-.59 2.672.689 3.224",
  transform: "translate(-63 -183) translate(63 185) translate(98) translate(.758 .358) translate(.242 .642)"
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaneSuccess);
export default ForwardRef;